import styled from "styled-components";
export const VerticalGamesListBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.background};

  & .card {
    border: none;
  }
`;